<template>
  <section class="hero section center-content" :class="[hasBgColor && 'has-bg-color', invertColor && 'invert-color']">
    <div class="container-sm">
      <div class="hero-inner section-inner" :class="[topDivider && 'has-top-divider', bottomDivider && 'has-bottom-divider']">
        <div class="hero-content">
          <h1 class="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">Control your server through Discord</h1>
          <div class="container-xs">
            <p class="m-0 mb-16 reveal-from-bottom" data-reveal-delay="400">
              Start using SRVControl to control your Pterodactyl servers quickly and easily via Discord.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionProps } from '@/utils/SectionProps.js';

export default {
  name: 'CHeroFull',
  mixins: [SectionProps]
};
</script>
